import { atom } from 'recoil';

export const isGreaseTrapFilterModalOpenAtom = atom<boolean>({
  key: 'isGreaseTrapFilterModalOpenState',
  default: false,
});
